/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconMobileArrowRight from '@telus-uds/palette-public-mobile/build/rn/icons/MobileArrowRight'
import PaletteIconMobileArrowBack from '@telus-uds/palette-public-mobile/build/rn/icons/MobileArrowBack'
const theme = {
  appearances: { inline: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inline: true },
      tokens: { calendarBackgroundColor: '#ffffff' }
    }
  ],
  tokens: {
    calendarBackgroundColor: '#f9f2dd',
    calendarDayBlockedCalendarHoverBackground: '#cdcfd5',
    calendarDayBlockedCalendarHoverColor: '#9c9faa',
    calendarDayDefaultBackgroundColor: '#f9f2dd',
    calendarDayDefaultBorder: 1,
    calendarDayDefaultBorderColor: '#cdcfd5',
    calendarDayDefaultCalendarDaySelectedHoverBackground: '#f39d80',
    calendarDayDefaultCalendarDaySelectedHoverBeforeBackground: '#f39d80',
    calendarDayDefaultCalendarDaySelectedHoverColor: '#394056',
    calendarDayDefaultColor: '#394056',
    calendarDayDefaultFontName: 'SofiaPro',
    calendarDayDefaultFontSize: 18,
    calendarDayDefaultFontWeight: '700',
    calendarDaySelectedDisabledBackground: '#cdcfd5',
    calendarDaySelectedDisabledColor: '#cdcfd5',
    calendarDaySelectedDisabledContentBackgroundColor: '#9c9faa',
    calendarDaySelectedFocusBeforeBackground: '#f39d80',
    calendarDaySelectedHoverBackground: '#f9f2dd',
    calendarDaySelectedHoverBeforeBackground: '#f9f2dd',
    calendarDaySelectedHoverBeforeBorderColor: '#f39d80',
    calendarDaySelectedHoverBorderColor: '#cdcfd5',
    calendarDaySelectedHoverColor: '#394056',
    calendarMonthCaptionColor: '#2b3145',
    calendarMonthCaptionFontName: 'SofiaPro',
    calendarMonthCaptionFontSize: 20,
    calendarMonthCaptionFontWeight: '700',
    calendarMonthCaptionLineHeight: 1.2,
    calendarMonthCaptionPaddingBottom: 46,
    dateInputStrokeColor: '#cdcfd5',
    dayPickerNavigationButtonPadding: 12,
    dayPickerWeekHeaderColor: '#394056',
    dayPickerWeekHeaderFontName: 'SofiaPro',
    dayPickerWeekHeaderFontWeight: '700',
    dayPickerWeekHeaderLineHeight: 1.5,
    dayPickerWeekHeaderSmall: 16,
    hiddenInputFieldContainerHeight: 0,
    hiddenInputFieldContainerWidth: 0,
    invalidInputMixin: null,
    nextIcon: PaletteIconMobileArrowRight,
    previousIcon: PaletteIconMobileArrowBack,
    singleDatePickerBorderColor: '#cdcfd5',
    singleDatePickerLeftRight: 16,
    singleDatePickerPaddingTopBottom: 8,
    singleDatePickerRadius: 8,
    validInputMixin: null
  }
}
export default theme
